import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface Generator {
  generator_id: string;
  generator_name: string;
}

interface UseGeneratorsSearchParams {
  searchQuery?: string;
  enabled?: boolean;
}

export const useGeneratorsSearch = ({ searchQuery = '', enabled = true }: UseGeneratorsSearchParams = {}) => {
  return useQuery({
    queryKey: ['generators-search', searchQuery],
    queryFn: async () => {
      console.log('[useGeneratorsSearch] Buscando geradores com query:', searchQuery);
      
      // Se há uma busca específica, faz query simples
      if (searchQuery && searchQuery.trim()) {
        const searchTerm = searchQuery.trim();
        console.log('[useGeneratorsSearch] Aplicando filtro:', searchTerm);
        
        const { data, error } = await supabase
          .from('generators')
          .select('generator_id, generator_name')
          .is('deleted_at', null)
          .ilike('generator_name', `%${searchTerm}%`)
          .order('generator_name', { ascending: true })
          .limit(100);

        if (error) {
          console.error('[useGeneratorsSearch] Erro ao buscar geradores:', error);
          throw error;
        }

        console.log('[useGeneratorsSearch] Geradores encontrados:', data?.length);
        return (data || []) as Generator[];
      }

      // Sem busca: paginar para buscar todos os geradores
      const pageSize = 1000;
      let pageIndex = 0;
      let hasMore = true;
      const all: Generator[] = [];

      while (hasMore) {
        const start = pageIndex * pageSize;
        const end = start + pageSize - 1;
        
        const { data, error } = await supabase
          .from('generators')
          .select('generator_id, generator_name')
          .is('deleted_at', null)
          .order('generator_name', { ascending: true })
          .range(start, end);

        if (error) {
          console.error('[useGeneratorsSearch] Erro ao buscar geradores:', error);
          throw error;
        }

        const batch = data || [];
        console.log(`[useGeneratorsSearch] Batch ${pageIndex + 1}:`, batch.length, `items (range ${start}-${end})`);
        all.push(...batch);
        hasMore = batch.length === pageSize;
        pageIndex += 1;
        
        // Safeguard
        if (pageIndex > 100) {
          console.warn('[useGeneratorsSearch] Pagination stopped after 100 pages safeguard.');
          break;
        }
      }

      console.log('[useGeneratorsSearch] Total geradores encontrados:', all.length);
      return all;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
};
